/**
 * jctc/staff_section modal scrollbar + Escape-to-close.
 *
 * The staff modal itself (section-templates/staff_section.php) is pure
 * CSS :target -- no JS drives opening/closing it, per explicit instruction.
 * Thin wrapper around modules/target-modal-scrollbar.js (JCTCTAS-227 --
 * extracted once modules/programs-modal.js needed the exact same mechanism
 * for a second `:target` modal) -- see that module's own doc comment for
 * why this exists at all (native scrollbar styling isn't stylable on
 * mobile browsers, and a pure `:target` modal has no keydown listener of
 * its own for Escape).
 */

import initTargetModalScrollbar from './target-modal-scrollbar.js';

export default function initStaffModal() {
    initTargetModalScrollbar({
        scrollAreaSelector:
            '.staff-modal:target .staff-modal__bio, .staff-modal:target .staff-modal__panel',
        panelSelector: '.staff-modal__panel',
        targetSelector: '.staff-modal',
        closedHash: 'staff-modal-closed',
    });
}
